import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import API from "../../Network/API";
import SettingNav from "./SettingNav";
import { USER_LOGGED_IN } from "../../Reducer/authSlice";

export default function LanguageSetting() {
    const { user, accessToken } = useSelector((state) => state.authReducer);
    const select_language = useSelector((state) => state.languageReducer);
    const dispatch = useDispatch();
    // start with the saved languages, or one empty row for new teachers
    const [selectedLanguages, setLanguages] = useState(
        user?.languages?.length ? user.languages : [{ language_id: '', type: '' }]
    );
    const [loading, setLoad] = useState(false);

    const langTypeOptions = [
        { value: 'basic', label: 'Basic' },
        { value: 'native', label: 'Native' },
        { value: 'fluent', label: 'Fluent' },
        { value: 'conversational', label: 'Conversational' },
    ];

    const addMoreFields = () => {
        setLanguages([...selectedLanguages, { language_id: '', type: '' }]);
    };

    const removeField = (index) => {
        if (selectedLanguages.length <= 1) return;
        const newLanguages = [...selectedLanguages];
        newLanguages.splice(index, 1);
        setLanguages(newLanguages);
    };

    const updateField = (index, field, value) => {
        const newLanguages = [...selectedLanguages];
        newLanguages[index] = { ...newLanguages[index], [field]: value };
        setLanguages(newLanguages);
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const languageData = selectedLanguages
            .filter((lang) => lang.language_id && lang.type)
            .map((lang) => ({ language_id: lang.language_id, type: lang.type }));

        if (languageData.length === 0) {
            toast.error('Please select at least one language with a proficiency level');
            return;
        }

        setLoad(true);

        API.post("/v1/oauth/teacher/settings/languages", {
            user_id: user.id,
            languages: languageData
        })
            .then((response) => {
                setLoad(false);
                toast.success("Languages updated successfully!");
                localStorage.setItem(
                    'xller_auth',
                    JSON.stringify({
                        user: response?.data?.data?.user,
                        accessToken: localStorage.getItem('xller_token'),
                    })
                )

                const userInfo = JSON.parse(localStorage.getItem("xller_auth"));
                if (userInfo) {
                    dispatch(USER_LOGGED_IN(userInfo));
                }
            })
            .catch((err) => {
                setLoad(false);
                toast.error(err?.response?.data?.message || 'Could not update languages. Please try again.');
            });
    };

    return (
        <div className="settings-widget card-details shadow-sm">
            <div className="settings-menu p-0">
                <div className="profile-heading">
                    <h3>Settings</h3>
                    <p>You have full control to manage your own account settings</p>
                </div>
                <div className="settings-page-head">
                    <SettingNav active_menu={`languages`} />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="checkout-form settings-wrap">
                        <div className="edit-profile-info">
                            <h5>Languages</h5>
                            <p>Tell students which languages you speak and how well</p>
                        </div>

                        <div className="form-group mb-3 row">
                            {selectedLanguages.map((lang, index) => (
                                <div className="form-group mb-2 row" key={index}>
                                    <div className="col-12">
                                        <div className="input-group">
                                            <select
                                                name={`languages[${index}][language_id]`}
                                                className="form-select"
                                                value={lang.language_id || ''}
                                                onChange={(e) => updateField(index, 'language_id', e.target.value)}
                                            >
                                                <option value="">Select language</option>
                                                {!select_language?.loading && select_language?.data?.map((language) => (
                                                    <option key={language.id} value={language.id}>
                                                        {language.name}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                name={`languages[${index}][type]`}
                                                className="form-select"
                                                value={lang.type || ''}
                                                onChange={(e) => updateField(index, 'type', e.target.value)}
                                            >
                                                <option value="">Select level</option>
                                                {langTypeOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {index === selectedLanguages.length - 1 && (
                                                <button className="input-group-text" type="button" title="Add another language" onClick={addMoreFields}>
                                                    <i className="fa-solid fa-plus-circle"></i>
                                                </button>
                                            )}
                                            {selectedLanguages.length > 1 && (
                                                <button className="input-group-text" type="button" title="Remove" onClick={() => removeField(index)}>
                                                    <i className="fa-solid fa-minus-circle text-danger"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="mb-3 d-flex justify-content-end">
                            <button type="submit" disabled={loading} className="input-hight-44 btn btn-login box-shadow-1 fw-bold">
                                Update {loading ? (
                                    <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span>
                                ) : (
                                    <span></span>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
